import { emptyError } from "../../Types/ServicesType/servicesType";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {reportsApi}=api
export const codificationreportsearchservice = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi?.codificationStatusreport,{...data,clinicId})
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const codificationreportpdfervice = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi?.codificationStatusreportpdf,{...data,clinicId})
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const codificationreportexcelervice = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi?.codificationStatusreportexcel,{...data,clinicId})
        return result.data
    } catch (error) {
        return emptyError
    }
}